import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';

// ─── Texte der Installation ─────────────────────────────────────────────────
//
// Name, Untertitel, Hinweise, Fußzeile – gesetzt vom Betreiber in der Konsole.
// Ohne Anmeldung abrufbar, denn Name und Untertitel stehen schon auf der
// Anmeldeseite.
//
// Solange nichts geladen ist, gilt die eingebaute Vorgabe. Ein Kopfbereich,
// der beim ersten Laden kurz leer bleibt, sähe nach einem Fehler aus.

const VORGABEN: Record<string, string> = {
  'app.name': 'Stammbaum',
  'app.tagline': 'Die Geschichte Ihrer Familie',
  'app.welcome': 'Noch keine Personen vorhanden',
  'app.welcomeHint': 'Lege die erste Person an oder importiere eine GEDCOM-Datei.',
  'app.footer': '',
  'login.hint': '',
  'login.supportContact': '',
  'legal.imprint': '',
  'legal.privacy': '',
};

async function fetchTexte(): Promise<Record<string, string>> {
  const { data } = await apiClient.get<Record<string, string>>('/texts');
  return data;
}

export function useTexte() {
  const { data } = useQuery({
    queryKey: ['texts'],
    queryFn: fetchTexte,
    // Ändern sich selten und nur durch den Betreiber. Eine Stunde frisch zu
    // halten spart eine Abfrage bei jedem Seitenwechsel.
    staleTime: 60 * 60 * 1000,
    // Auch ohne Anmeldung – die Anmeldeseite braucht Namen und Untertitel.
    retry: false,
  });

  /** Ein Text, mit Vorgabe als Rückfall. */
  const text = (key: string): string => data?.[key] ?? VORGABEN[key] ?? '';

  return { text, geladen: Boolean(data) };
}
